import { GoogleAuthProvider, signInWithCredential } from 'firebase/auth';
import { auth } from '@/config/firebase';

const NATIVE_TIMEOUT_MS = 120000;

// Asks the iOS wrapper to run native Google Sign-In, then signs in to Firebase
// with the returned Google ID token. Only call when hasNativeGoogleBridge() is true.
export const signInWithGoogleNative = () => {
  return new Promise((resolve, reject) => {
    let timer = null;

    const onResult = async (event) => {
      clearTimeout(timer);
      const detail = event.detail || {};
      if (!detail.ok || !detail.idToken) {
        reject(new Error(detail.error || 'Google sign-in was cancelled'));
        return;
      }
      try {
        const credential = GoogleAuthProvider.credential(detail.idToken);
        const result = await signInWithCredential(auth, credential);
        resolve(result);
      } catch (err) {
        reject(err);
      }
    };

    window.addEventListener('nativeGoogleSignIn', onResult, { once: true });

    timer = setTimeout(() => {
      window.removeEventListener('nativeGoogleSignIn', onResult);
      reject(new Error('Google sign-in timed out. Please try again.'));
    }, NATIVE_TIMEOUT_MS);

    window.webkit.messageHandlers.nativeGoogleSignIn.postMessage({ action: 'signIn' });
  });
};
